module.exports = __webpack_public_path__ + "img/icon_filter.89ccf1a0.svg";